import React, { useEffect, useState, useRef } from 'react';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import ym from 'react-yandex-metrika';
import { ReCaptcha } from 'react-recaptcha-v3';
import { webmaster } from '../../services/ApiService';
import CustomControl from '../../ui/CustomControl';
import { redirectToOffice, shouldDisableRecaptcha } from '../../utils/utils';
import PasswordField from '../Forms/PasswordField';
import 'rc-tooltip/assets/bootstrap.css';
import ReactPixel from 'react-facebook-pixel';
import Tooltip from 'rc-tooltip';

const AffiliateEmailSignUpForm = ({ intl, reacaptcha_sitekey, onStateChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    login: '',
    telegram: 'nodata',
    email: '',
    password: '',
    // re_password: '',
    regulations: true,
    recaptchaToken: '',
  });
  const [currentState, setCurrentState] = useState('registration');
  const [sentToEmail, setSentToEmail] = useState('');
  const [isGmail, setIsGmail] = useState(false);
  const recaptchaRef = useRef(null);
  const isRecaptchaDisabled = shouldDisableRecaptcha();

  useEffect(() => {
    if (currentState) {
      onStateChange(currentState);
    }
  }, [currentState]);

  const formGroupClass = (field) =>
    errors[field] === undefined ? 'form-group' : 'form-group has-error';

  // const isTelegramValid = (tg) => /^(@|(http(s)?:\/\/)?t\.me\/)?\+?([a-z0-9_]{5,})$/i.test(tg); // На беке такая же проверка

  const validate = (data) => {
    const errors = {};

    const alwaysRequiredFields = ['login', 'email', 'password'];

    Object.keys(data).forEach((field) => {
      if (alwaysRequiredFields.includes(field)) {
        if (data[field].length === 0) {
          errors[field] = 'This field is required';
        } else if (field === 'login') {
          // Дополнительная валидация для login
          if (data.login.length < 3) {
            errors.login = intl.formatMessage({
              id: 'affiliate.register.errors.login.length',
              defaultMessage: 'Login must be at least 3 characters long',
            });
          } else if (!/^[a-zA-Z0-9_а-яА-ЯёЁ]+$/.test(data.login)) {
            errors.login = intl.formatMessage({
              id: 'affiliate.register.errors.login.invalid',
              defaultMessage: 'Login can only contain letters, numbers, and underscores',
            });
          }
        }
      }
      // if (!data['telegram'].trim().length && !data['skype'].trim().length) {
      //   errors['telegram'] = 'Please provide your skype or telegram login';
      //   errors['skype'] = 'Please provide your skype or telegram login';
      // } else if (data.telegram) {
      //   if (!this.isTelegramValid(data.telegram)) {
      //     errors['telegram'] = 'You need to enter a phone number or @name';
      //   }
      // }
    });

    if (data.password.length < 6) {
      errors.password = intl.formatMessage({
        id: 'affiliate.register.errors.password.length',
        defaultMessage: 'Your password must be a minimum of 6 letters or numbers',
      });
    }
    if (Object.keys(errors).length > 0) {
      return errors;
    }

    // if (data.re_password !== data.password) {
    //   errors.re_password = intl.formatMessage({
    //     id: 'affiliate.register.errors.password.missmatch',
    //     defaultMessage: 'Your password and confirmation password do not match.',
    //   });
    // }

    return errors;
  };

  const sendFormData = () => {
    const requestData = { ...data };
    if (isRecaptchaDisabled) {
      delete requestData.recaptchaToken;
    }

    webmaster
      .registration({
        ...requestData,
      })
      .then((data) => {
        if (!data.errors) {
          setCurrentState('activate');
          setSentToEmail(data.items.email);
          setIsGmail(data.items.email.includes('@gmail.com'));
          onStateChange('activate');
          ym('reachGoal', 'regsuccess', { email: data.email });
          ReactPixel.track('Lead');
          if (window.gtag) {
            window.gtag('event', 'regsuccess', {
              event_category: 'registration',
            });
            window.gtag('event', 'conversion', {
              send_to: 'AW-710210063/xZGpCP3UvawBEI_k09IC',
            });
          }
        }
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.error) {
          const { message: error } = response.data.error;

          const slaveConnectionError = handleErrorTypes(error);
          if (slaveConnectionError) {
            redirectToOffice(undefined, 0);
          }

          if (
            error.type === 'api.registration.email_exists' ||
            error.type === 'api.registration.wrong_email'
          ) {
            setErrors((prevState) => ({
              ...prevState,
              email: error.message,
            }));
            setIsLoading(false);
          } else {
            setErrors((prevState) => ({
              ...prevState,
              response: error.message,
            }));
            setIsLoading(false);
          }
        }
      });

    return false;
  };

  const handleErrorTypes = (err) => {
    const connectErrType = get(err, 'type');
    if (connectErrType && connectErrType === 'api.account.master_join_error') {
      return true;
    }
    return false;
  };

  const onChange = (e) => {
    const { target } = e;

    const value = target.type === 'checkbox' ? target.checked : target.value;

    setErrors({});
    setData((prevState) => ({
      ...prevState,
      [target.name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(data);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      if (isRecaptchaDisabled) {
        verifyCallback();
        return;
      }
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(reacaptcha_sitekey.v3, { action: 'registration' })
          .then((recaptchaToken) => {
            verifyCallback(recaptchaToken);
          });
      });
    }
  };

  const verifyCallback = (recaptchaToken) => {
    setData((prevState) => ({
      ...prevState,
      recaptchaToken: isRecaptchaDisabled ? '' : recaptchaToken,
    }));

    const { email, password } = data;

    if (currentState === 'registration') {
      if (email && password) {
        setIsLoading(true);
        sendFormData();
      }
    }
    if (currentState === 'login') {
      const redirectUrl = localStorage.getItem('redirect_url') || undefined;
      webmaster
        .login({ email, password, redirectUrl, recaptchaToken })
        .then((response) => response.items)
        .then(({ auth, redirectUrl }) => {
          if (auth) {
            ym('reachGoal', 'regsuccess', { email });
            if (window.gtag) {
              window.gtag('event', 'regsuccess', {
                event_category: 'registration',
              });
              window.gtag('event', 'conversion', {
                send_to: 'AW-710210063/xZGpCP3UvawBEI_k09IC',
              });
            }

            redirectToOffice(redirectUrl, 100);
          }
        });
    }
  };

  return currentState === 'registration' ? (
    <form onSubmit={onSubmit} className="form-hidden publisher-sign-up-form">
      {!isRecaptchaDisabled && reacaptcha_sitekey && reacaptcha_sitekey.v3 && (
        <ReCaptcha
          ref={recaptchaRef}
          sitekey={reacaptcha_sitekey.v3}
          size="invisible"
          render="explicit"
          action="registration"
          verifyCallback={verifyCallback}
        />
      )}
      {/* Name */}
      <div className={formGroupClass('login')}>
        <label className={!data.login ? 'label' : 'label label-upper'}>
          <FormattedMessage id="affiliate.register.name" defaultMessage="Name" />
        </label>
        <input
          className="form-control"
          name="login"
          value={data.login}
          onChange={onChange}
          disabled={isLoading}
          autoComplete="name"
          required
        />
        {errors.login && <small className="form-text">{errors.login}</small>}
      </div>
      {/* Email */}
      <div className={formGroupClass('email')}>
        <label className={!data.email ? 'label' : 'label label-upper'}>
          <FormattedMessage id="affiliate.register.mail" defaultMessage="Email" />
        </label>
        <input
          type="email"
          className="form-control"
          name="email"
          value={data.email}
          onChange={onChange}
          disabled={isLoading}
          required
          autoComplete="email"
        />
        {errors.email && <small className="form-text">{errors.email}</small>}
      </div>
      {/* Telegram */}
      {/* <div className={formGroupClass('telegram')}>
        <label className={!data.telegram ? 'label' : 'label label-upper'}>
          Telegram{' '}
          {data.telegram && (
            <Tooltip
              placement="right"
              trigger={['hover']}
              overlay={
                <span>
                  <FormattedMessage
                    id="registration.telegram.tooltip"
                    defaultMessage="Required, account activation takes place in Telegram"
                  />
                </span>
              }
            >
              <i className="icon-info" />
            </Tooltip>
          )}
        </label>
        <FormattedMessage
          id="registration.telegram.placeholder"
          defaultMessage="@nickname or t.me/nickname"
        >
          {() => (
            <input
              className="form-control"
              name="telegram"
              value={data.telegram}
              onChange={onChange}
              disabled={isLoading}
            />
          )}
        </FormattedMessage>
        {errors.telegram && (
          <small className="form-text">
            <FormattedMessage id="registration.telegram.error" defaultMessage="Error" />
          </small>
        )}
      </div> */}
      <div className={formGroupClass('password')}>
        <PasswordField
          label={<FormattedMessage id="affiliate.register.password" defaultMessage="Password" />}
          className="form-control"
          name="password"
          value={data.password}
          onChange={onChange}
          disabled={isLoading}
          autoComplete="new-password"
          required
        />
        {errors.password && <small className="form-text">{errors.password}</small>}
      </div>
      {/* <div className={this.formGroupClass('re_password')}>
          <PasswordField
            label={
              <FormattedMessage
                id="affiliate.register.password_confirm"
                defaultMessage="Confirm password"
              />
            }
            className="form-control"
            name="re_password"
            value={re_password}
            onChange={this.onChange}
            disabled={isLoading}
            autoComplete="none"
            required
          />
          {errors.re_password && <small className="form-text">{errors.re_password}</small>}
        </div> */}
      <div className={formGroupClass('regulations')}>
        <div className="form-check">
          <CustomControl
            className="regulations-checkbox"
            type="checkbox"
            id="regulations"
            name="regulations"
            onChange={onChange}
            checked={data.regulations}
            label={
              <FormattedHTMLMessage
                id="affiliate.register.regulations"
                defaultMessage="I agree with terms and conditions"
              />
            }
            disabled={isLoading}
            value="true"
          />
        </div>
      </div>
      {errors.response && <span className="form-error">{errors.response}</span>}
      <div className="form-controls text-center">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isLoading || !data.regulations}
        >
          {isLoading ? (
            <span className="loading-spinner loading-spinner-btn" />
          ) : (
            <FormattedMessage id="affiliate.auth.link.to_signup.button" defaultMessage="Sign Up" />
          )}
        </button>
      </div>
    </form>
  ) : (
    <div className="text-center form-almost-done">
      <FormattedMessage id="affiliate.auth.sentTo" defaultMessage="Email sent">
        {(message) => {
          const parse = message.split('$email');
          parse.splice(1, 0, <span className="text-color-publisher">{sentToEmail}</span>);
          return <p className="form-almost-done-text">{parse}</p>;
        }}
      </FormattedMessage>
      <p className="form-almost-done-text">
        <FormattedMessage id="affiliate.auth.spam_1" defaultMessage="Email sent" />
      </p>
    </div>
  );
};

const mapStateToProps = ({ app }) => ({
  reacaptcha_sitekey: app.authSettings.recaptcha,
});

export default connect(mapStateToProps)(injectIntl(AffiliateEmailSignUpForm));
